<template>
    <div class="page-container">
        <div class="page-header content-fade-in">
            <h1 class="title">实时会议</h1>
            <div class="subtitle">开展实时会议，AI识别发言人及发言内容，即时生成总结</div>
        </div>
        
        <div class="content-container content-slide-up" style="animation-delay: 0.1s;">
            <div class="form-header">
                <div class="meeting-icon-box">
                    <i class="meeting-icon-inner"></i>
                </div>
                <div class="meeting-desc">填写会议基本信息，开始语音识别</div>
            </div>
            
            <div class="form-wrapper">
                <a-form ref="formRef" class="mt-form" :model="formState" name="dynamic_rule" v-bind="formItemLayout"
                    hideRequiredMark>
                    <a-form-item label="会议名称" name="name" :rules="[{ required: true, message: '请输入会议名称' }]">
                        <a-input v-model:value="formState.name" placeholder="请输入会议名称" allowClear />
                    </a-form-item>
        
                    <a-form-item label="录音方式" name="meettype" :rules="[{ required: true, message: '请选择录音方式' }]">
                        <a-radio-group v-model:value="formState.meettype" name="meettype">
                            <a-radio :value="1">单麦克风</a-radio>
                            <a-radio :value="2">多麦克风</a-radio>
                        </a-radio-group>
                        <a-button v-if="formState.meettype == 2" type="primary" size="small" class="add-micro-btn" @click="addMicro">
                            <plus-outlined />添加麦克风
                        </a-button>
                    </a-form-item>
        
                    <a-form-item v-if="formState.meettype == 1" label="参会人员" name="users">
                        <a-select v-model:value="formState.users" mode="multiple" label-in-value placeholder="选择参会人员"
                            style="width: 100%" :filter-option="false" :not-found-content="state.fetching ? undefined : null"
                            :options="state.data">
                            <template v-if="state.fetching" #notFoundContent>
                                <a-spin size="small" />
                            </template>
                        </a-select>
                    </a-form-item>
                    
                    <div v-if="formState.meettype == 2" class="multi-mic-container">
                        <div class="multi-mic-title">参会人员（多麦克风）</div>
                        <div class="multi-mic-list">
                            <div class="mic-item card-item" v-for="(item, index) in microList" :key="index">
                                <div class="mic-header">
                                    <div class="mic-number">麦克风 {{ index + 1 }}</div>
                                    <delete-outlined 
                                        v-if="microList.length > 1" 
                                        class="delete-icon" 
                                        @click="deleteMicro(index)" 
                                    />
                                </div>
                                <a-select 
                                    v-model:value="item.user" 
                                    label-in-value 
                                    placeholder="选择参会人员"
                                    class="mic-select"
                                    :filter-option="false"
                                    :not-found-content="state.fetching ? undefined : null" 
                                    :options="state.data"
                                >
                                    <template v-if="state.fetching" #notFoundContent>
                                        <a-spin size="small" />
                                    </template>
                                </a-select>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-button-container">
                        <a-button type="primary" size="large" class="start-button button-shimmer" @click="addMeettings">
                            开始会议
                        </a-button>
                    </div>
                </a-form>
            </div>
            
            <div class="meeting-tips">
                <div class="tips-title">会议小贴士</div>
                <ul class="tips-list">
                    <li>请在安静的环境下进行会议，以获得更好的识别效果</li>
                    <li>多麦克风模式下，每个参会人员应使用独立的麦克风</li>
                    <li>实时会议过程中可随时查看识别结果和生成的摘要</li>
                    <li>添加参会人员信息有助于AI更准确地识别发言人</li>
                </ul>
                
                <div class="meeting-format-info">
                    <div class="format-header">环境要求</div>
                    <div class="format-items">
                        <div class="format-item">
                            <span class="format-label">噪音水平：</span>
                            <span class="format-value">尽量安静</span>
                        </div>
                        <div class="format-item">
                            <span class="format-label">麦克风：</span>
                            <span class="format-value">高质量，避免杂音</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, ref, watch, computed, onActivated } from 'vue';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { BASE_URL } from '@/config/api';

const router = useRouter();
const formRef = ref();
let lastFetchId = 0;

const formState = reactive({
    name: '',
    users: [],
    meettime: '',
    meettype: 1,
});

const state = reactive({
    data: [],
    value: [],
    fetching: false,
});

// 麦克风列表
const microList = ref([
    { id: 1 },
    { id: 2 }
]);

// 添加麦克风
const addMicro = () => {
    microList.value.push({
        id: microList.value.length + 1
    });
};

// 删除麦克风
const deleteMicro = (index) => {
    microList.value.splice(index, 1);
};

const set_init = () => {
    // 发起请求查询是否有正在进行中的会议
    // 如果有正在进行中的会议，跳转到 /current
    // 如果没有正在进行中的会议，继续执行
    fetch(`${BASE_URL}/meeting?meeting_status=1&active_id=${myPermission.value.id}`)
        .then(response => response.json())
        .then(data => {
            console.log('data', data);
            if (data.items.length > 0) {
                let id = data.items[0].id;
                router.push({ path: '/meetingongoing/' + id });
            } else {
                // Continue with the rest of the code
            }
        }).catch(() => {
            console.log('error');
        });
};

const myPermission = computed(() => {
    const permission = localStorage.getItem('myPermission') || '{}';
    return JSON.parse(permission);
});

onActivated(() => {
    set_init();
});

set_init();

watch(
    () => formState.checkNick,
    () => {
        formRef.value.validate(['nickname']);
    },
    {
        flush: 'post',
    },
);

const addMeettings = async () => {
    formRef.value.validate().then(async () => {
        // post 调用 API
        const response = await fetch(`${BASE_URL}/meeting`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                title: formState.name,
                usersList: formState.users.map(user => user.key),
                start_time: "立刻开始",
                remark: '',
                active_id: myPermission.value.id,
            })
        });
        const data = await response.json();
        console.log('response', data);
        router.push({ path: '/meetingongoing/' + data.id });
    }).catch(() => { });
};

const formItemLayout = {
    wrapperCol: {
        flex: '1'
    },
};

const handleChange = () => {
    lastFetchId += 1;
    const fetchId = lastFetchId;
    state.data = [];
    state.fetching = true;
    fetch(`${BASE_URL}/user?active_id=${myPermission.value.id}`)
        .then(response => response.json())
        .then(body => {
            if (fetchId !== lastFetchId) {
                // for fetch callback order
                return;
            }
            console.log('body', body);
            const data = body.items.map(user => ({
                label: user.name,
                value: user.id,
            }));
            state.data = data;
            state.fetching = false;
        });
};

handleChange();
</script>

<style scoped lang="less">
.page-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 24px;
}

.page-header {
    margin-bottom: 24px;
}

.content-container {
    display: grid;
    grid-template-columns: 1fr 300px;
    grid-gap: 24px;
    padding: 0;
    box-shadow: none;
    background: transparent;
    height: auto;
}

.form-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding: 0 24px;
}

.meeting-icon-box {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #3B82F6, #246BF0);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.meeting-icon-inner {
    width: 24px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z' /%3E%3C/svg%3E");
    background-size: contain;
}

.meeting-desc {
    font-size: 16px;
    font-weight: 500;
    color: #1E293B;
}

.form-wrapper {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: var(--card-shadow);
    padding: 24px;
    grid-column: 1 / 2;
}

.meeting-tips {
    background-color: #fff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: var(--card-shadow);
    grid-column: 2 / 3;
    align-self: start;
}

.tips-title {
    font-size: 16px;
    font-weight: 600;
    color: #0F172A;
    margin-bottom: 16px;
    border-bottom: 1px solid #E2E8F0;
    padding-bottom: 12px;
}

.tips-list {
    padding-left: 20px;
    margin: 0 0 24px 0;
    
    li {
        margin-bottom: 12px;
        color: #64748B;
        line-height: 1.5;
        
        &:last-child {
            margin-bottom: 0;
        }
    }
}

.meeting-format-info {
    background-color: #F8FAFC;
    border-radius: 8px;
    padding: 16px;
    margin-top: 20px;
}

.format-header {
    font-weight: 600;
    color: #334155;
    margin-bottom: 12px;
    font-size: 14px;
}

.format-items {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.format-item {
    display: flex;
    font-size: 13px;
    
    .format-label {
        color: #64748B;
        min-width: 80px;
    }
    
    .format-value {
        color: #334155;
        font-weight: 500;
    }
}

.mt-form {
    width: 100%;
}

.add-micro-btn {
    margin-left: 16px;
}

.multi-mic-container {
    margin-bottom: 32px;
}

.multi-mic-title {
    font-weight: 500;
    color: #1E293B;
    margin-bottom: 16px;
}

.multi-mic-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.mic-item {
    flex: 0 0 calc(50% - 8px);
    background-color: #F8FAFC;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #E2E8F0;
    transition: all 0.2s ease;
    
    &:hover {
        border-color: #CBD5E1;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
}

.mic-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.mic-number {
    font-weight: 500;
    color: #334155;
}

.delete-icon {
    color: #94A3B8;
    cursor: pointer;
    padding: 4px;
    font-size: 16px;
    transition: all 0.2s ease;
    
    &:hover {
        color: #EF4444;
    }
}

.mic-select {
    width: 100%;
}

.form-button-container {
    display: flex;
    justify-content: center;
    margin-top: 40px;
}

.start-button {
    min-width: 200px;
    height: 48px !important;
    font-size: 16px;
    font-weight: 600;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: linear-gradient(135deg, #3B82F6, #246BF0) !important;
    border-color: #3B82F6 !important;
}

@media (max-width: 1200px) {
    .content-container {
        grid-template-columns: 1fr;
    }
    
    .meeting-tips {
        grid-column: 1 / 2;
    }
}
</style>